export default "__VITE_ASSET__af088ca9__"